import { render, staticRenderFns } from "./ConsumeList.vue?vue&type=template&id=c2612bf0&scoped=true"
import script from "./ConsumeList.vue?vue&type=script&lang=js"
export * from "./ConsumeList.vue?vue&type=script&lang=js"
import style0 from "./ConsumeList.vue?vue&type=style&index=0&id=c2612bf0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2612bf0",
  null
  
)

export default component.exports